import { graphql } from '@repo/common/queries/schemas/server_admin_query'

export const query_get_users_by_wallet = graphql(`
  query query_get_users_by_wallet($wallet_addresses: [String!]!) {
    users_by_wallet(wallet_addresses: $wallet_addresses) {
      id
      uuid
      email
      name
      wallet_address
      wallet_provider
      roles
      active_at
      created_at
      updated_at
      image
      locked
    }
  }
`)
